import { Cartridge, CartridgeGroup, CartridgeStatus } from '../cartridges.models';
import { OrganizationType } from 'data-model';

export const MOCK_CARTRIDGE_GROUP: CartridgeGroup[] = [
  {
    id: '67475b5c893f9d13a1fbbe77',
    cmsId: '191',
    key: 'PROTOTYPE',
    name: 'Service Group Prototyp',
    description:
      'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
    image: 'https://cdn-eu.aglty.io/markant/eInvoicing_AdobeStock_561762961_einfache%20Lizenz_markant.png',
    icon: 'eservice_produktstammdaten_promis_positiv',
  },
];

export const MOCK_CARTRIDGES: Cartridge[] = [
  {
    id: '63908b0f40aab46a5c4bb46c',
    name: 'Cartridge prototype',
    longName: 'Cartridge prototype long name',
    description: 'Prototype implementation of an external cartridge.',
    longDescription:
      'Prototype implementation of an external cartridge. The cartridge offers several widgets and focus views with different functionalities. These are intended to demonstrate how a cartridge can be developed and integrated into the platform.',
    icon: 'eservice_archivierung_positiv',
    status: CartridgeStatus.ACTIVE,
    contentId: '91',
    key: 'TESTSERVICE1',
    variants: [
      {
        variantId: '1234e29544e9fd436c21be4f',
        type: 'STANDARD',
        contentId: '443',
        name: 'Cartridge prototype Variant 1',
        description: '<p>Description Variant 1</p>',
        longDescription: '<p>Long Description Variant 1</p>',
        calculationParameters: [
          'Up to 125 analyses, favorites and alarms can be saved in the personal area',
          '50,000 to 500,000 incoming goods delivery bills per year',
          'Maximum turnover of 10 million euros per year',
          '400 to 799 GTIN-target market combinations',
          'More than 60 products recorded per year',
          'Some other parameter\r\nWith new line',
        ],
        variantFeatures: ['2324', '2326'],
        image: '',
        icon: 'eservice_kosten-rechnungs-workflow-positiv',
        price: {
          currency: 'EUR',
          centAmount: 20000,
          priceModel: 'SUBSCRIPTION',
          billingPeriod: 'MONTHLY',
          hasToBeRequested: false,
          targetAudience: {
            organizationType: OrganizationType.DEALER,
            ezr: false,
          },
        },
        prices: [
          {
            currency: 'EUR',
            centAmount: 20000,
            priceModel: 'SUBSCRIPTION',
            billingPeriod: 'MONTHLY',
            hasToBeRequested: false,
            targetAudience: {
              organizationType: OrganizationType.DEALER,
              ezr: false,
            },
          },
        ],
        remoteEntry: 'http://localhost:4300/remoteEntry.js',
        contractPeriod: 6,
        allowUiBooking: true,
        allowEcsSelfBooking: false,
        requireIntegrationProject: true,
        variantStatus: CartridgeStatus.ACTIVE,

        setUpCost: {
          currency: 'EUR',
          centAmount: 29999,
          targetAudience: {
            organizationType: OrganizationType.DEALER,
            ezr: false,
          },
        },
        usagePeriodInDays: undefined,
      },
    ],
    legalNoticeLinks: ['DEALER', 'DEALER_EZR', 'SUPPLIER', 'SUPPLIER_EZR'],
    cartridgeGroupKey: 'PROTOTYPE',
    marketingInformation: [
      {
        headlineRight:
          'Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis.',
        textInformationRight:
          '<p>Die Wahrung der Menschenrechte und grundlegender Umweltstandards entlang der Lieferkette ist jedoch nicht möglich, ohne dabei auch die Zulieferer betroffener Unternehmen einzubeziehen. Die Auswirkungen des LkSG sind damit weitaus grösser, als es der Kreis der vom Gesetz verpflichteten Unternehmen zunächst vermuten lässt. Im Folgenden sollen Ihnen die Grundzüge des LkSG und dessen Auswirkungen auf Sie als Lieferanten näher gebracht werden.</p>',
        image: {
          label: 'Marketing Content 1',
          url: 'https://cdn-eu.aglty.io/markant/Attachments/NewItems/marketing_content_1.png?q=90&format=auto',
          height: 1187,
          width: 1600,
        },
        informationContentType: 'image',
        informationContentTypeRight: 'text',
      },
    ],
    cartridgeFeatures: [
      {
        contentId: '2326',
        description: 'Monitoring & tracking of products, stocks & deliveries.',
        sortOrder: 2,
      },
    ],
    remoteEntry: '',
    serviceUpgradeState: null,
  },
  {
    id: '63908b0f40aab46a5c4bb46d',
    name: 'Cartridge prototype (Bulk prices)',
    longName: 'Cartridge prototype (Bulk prices) long name',
    description: 'Prototype implementation of an external cartridge with bulk prices.',
    longDescription:
      'Prototype implementation of an external cartridge with bulk prices. The cartridge offers several widgets and focus views with different functionalities. These are intended to demonstrate how a cartridge can be developed and integrated into the platform.',
    icon: 'eservice_archivierung_positiv',
    status: CartridgeStatus.ACTIVE,
    contentId: '91',
    key: 'TESTSERVICE2',
    variants: [
      {
        variantId: '6648decf9a98211ee036f821',
        contentId: '445',
        type: 'STANDARD',
        name: 'Price Tier Variant (Total)',
        description: '<p>This variant provides an example for using a price tier (total).</p>',
        longDescription: '<p>This variant provides an example for using a price tier (total).</p>',
        image: 'https://cdn-eu.aglty.io/markant/eInvoicing_AdobeStock_561762961_einfache%20Lizenz_markant.png',
        icon: 'eservice_personal_positiv',
        price: {
          currency: 'EUR',
          centAmount: 0,
          priceModel: 'STAGGERED_FIXED_PRICE',
          billingPeriod: 'MONTHLY',
          targetAudience: {
            organizationType: OrganizationType.DEALER,
            ezr: false,
          },
          bulkPrices: [],
        },
        prices: [
          {
            currency: 'EUR',
            priceModel: 'STAGGERED_FIXED_PRICE',
            billingPeriod: 'MONTHLY',
            centAmount: 2000,
            hasToBeRequested: false,
            targetAudience: {
              organizationType: OrganizationType.DEALER,
              ezr: false,
            },
          },
          {
            currency: 'EUR',
            centAmount: 100000,
            priceModel: 'FIXED_PRICE',
            billingPeriod: 'NONE',
            hasToBeRequested: false,
            targetAudience: {
              organizationType: OrganizationType.SUPPLIER,
              ezr: false,
            },
          },
        ],
        remoteEntry: 'http://localhost:4300/remoteEntry.js',
        widgets: [],
        apis: [],
        contractPeriod: 6,
        allowUiBooking: true,
        allowEcsSelfBooking: false,
        requireIntegrationProject: false,
        variantStatus: CartridgeStatus.ACTIVE,
        usagePeriodInDays: undefined,
      },
      {
        variantId: '1234e29544e9fd436c21be6b',
        contentId: '443',
        type: 'STANDARD',
        name: 'Roadtrip with the car YEARLY variant - subscription',
        description:
          '<p>Description Variant 1  with a long title to test the capabilites of the UI to show adaptable cards</p>',
        longDescription: '<p>Long Description Variant 1</p>',
        image: '',
        icon: 'eservice_kosten-rechnungs-workflow-positiv',
        price: {
          currency: 'EUR',
          centAmount: 20000,
          priceModel: 'SUBSCRIPTION',
          billingPeriod: 'MONTHLY',
          hasToBeRequested: false,
          targetAudience: {
            organizationType: OrganizationType.DEALER,
            ezr: false,
          },
        },
        prices: [
          {
            currency: 'EUR',
            centAmount: 20000,
            priceModel: 'SUBSCRIPTION',
            billingPeriod: 'MONTHLY',
            hasToBeRequested: false,
            targetAudience: {
              organizationType: OrganizationType.DEALER,
              ezr: false,
            },
          },
          {
            currency: 'EUR',
            centAmount: 100000,
            priceModel: 'FIXED_PRICE',
            billingPeriod: 'NONE',
            hasToBeRequested: false,
            targetAudience: {
              organizationType: OrganizationType.SUPPLIER,
              ezr: true,
            },
          },
        ],
        remoteEntry: 'http://localhost:4300/remoteEntry.js',
        widgets: [],
        apis: [],
        contractPeriod: 6,
        allowUiBooking: true,
        allowEcsSelfBooking: false,
        requireIntegrationProject: true,
        variantStatus: CartridgeStatus.ACTIVE,
        usagePeriodInDays: undefined,
      },
    ],
    legalNoticeLinks: ['DEALER', 'DEALER_EZR', 'SUPPLIER', 'SUPPLIER_EZR'],
    cartridgeGroupKey: 'PROTOTYPE',
    marketingInformation: [],
    remoteEntry: '',
    serviceUpgradeState: null,
    cartridgeFeatures: [],
  },
];
